import { BaseProps } from '@/components/types'
import { Icon, List, Button, CardListItem, SeeMore } from '@/components'
import { useState } from 'react'

function Comment ( props: CommentProps ) {
    const {
        commentList, defaultShowCommentCount = 5,
        onDeleteComment
    } = props
    const [ showCommentCount, setShowCommentCount ] = useState( defaultShowCommentCount )
    return (
        commentList && <List>
            {
                commentList.map( ( data, idx ) => {
                    const { userId, userName, commentId, commentText } = data
                    return (
                        <CardListItem
                            key={ `${ commentId }${ idx }` }
                            primaryText={ userName }
                            secondaryText={ commentText }
                            rightContents={
                                userId === 'admin' &&
                                    <>
                                        <Button
                                            fullWidth
                                            size="small"
                                            onClick={ () => onDeleteComment && onDeleteComment( data ) }
                                        >
                                            <Icon>delete</Icon>
                                        </Button>
                                    </>
                            }
                        />
                    )
                } ).slice( 0, showCommentCount > commentList.length ? commentList.length : showCommentCount )
            }
            {
                <SeeMore
                    defaultShowCount={ defaultShowCommentCount }
                    setShowCount={ setShowCommentCount }
                    totalList={ commentList }
                />
            }
        </List>
    )
}

export default Comment

export interface IComment {
    userId: string
    userName: string
    commentId: string
    commentText: string
    registDate?: string
}

export interface CommentProps extends BaseProps {
    defaultShowCommentCount?: number
    commentList?: IComment[]
    onDeleteComment?: Function
}